import { createFileRoute } from '@tanstack/react-router'
import ContactContainer from 'Contact/containers/ContactContainer'
import { contactQueries } from 'Contact/utils/queries'
import { claimTypesEnum } from 'User/utils/claims'

import { PageSkeleton } from 'Common/components/skeletons'

import { Guard } from '../-guard'
import { prefetchWhenAuthenticated } from '../-prefetch'

export const Route = createFileRoute('/contact/$contactId')({
    loader: ({ context, params }) =>
        prefetchWhenAuthenticated(
            context.queryClient,
            contactQueries.detail(Number(params.contactId)),
        ),
    pendingComponent: () => <PageSkeleton variant="detail" />,
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_contacts]}>
            <ContactContainer />
        </Guard>
    ),
})
